var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChatMoniter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_212_1765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 17C2 8.16344 9.16344 1 18 1C26.8366 1 34 8.16344 34 17C34 25.8366 26.8366 33 18 33C9.16344 33 2 25.8366 2 17Z",
    fill: "url(#paint0_linear_212_1765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 25H10.5V9H25.5V25Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_1765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 10.5C18.4148 10.5 18.75 10.8352 18.75 11.25V12.75H21.5625C22.4953 12.75 23.25 13.5047 23.25 14.4375V20.8125C23.25 21.7453 22.4953 22.5 21.5625 22.5H14.4375C13.5047 22.5 12.75 21.7453 12.75 20.8125V14.4375C12.75 13.5047 13.5047 12.75 14.4375 12.75H17.25V11.25C17.25 10.8352 17.5852 10.5 18 10.5ZM15.375 19.5C15.1687 19.5 15 19.6687 15 19.875C15 20.0813 15.1687 20.25 15.375 20.25H16.125C16.3313 20.25 16.5 20.0813 16.5 19.875C16.5 19.6687 16.3313 19.5 16.125 19.5H15.375ZM17.625 19.5C17.4187 19.5 17.25 19.6687 17.25 19.875C17.25 20.0813 17.4187 20.25 17.625 20.25H18.375C18.5813 20.25 18.75 20.0813 18.75 19.875C18.75 19.6687 18.5813 19.5 18.375 19.5H17.625ZM19.875 19.5C19.6687 19.5 19.5 19.6687 19.5 19.875C19.5 20.0813 19.6687 20.25 19.875 20.25H20.625C20.8313 20.25 21 20.0813 21 19.875C21 19.6687 20.8313 19.5 20.625 19.5H19.875ZM16.6875 16.5C16.6875 16.2514 16.5887 16.0129 16.4129 15.8371C16.2371 15.6613 15.9986 15.5625 15.75 15.5625C15.5014 15.5625 15.2629 15.6613 15.0871 15.8371C14.9113 16.0129 14.8125 16.2514 14.8125 16.5C14.8125 16.7486 14.9113 16.9871 15.0871 17.1629C15.2629 17.3387 15.5014 17.4375 15.75 17.4375C15.9986 17.4375 16.2371 17.3387 16.4129 17.1629C16.5887 16.9871 16.6875 16.7486 16.6875 16.5ZM20.25 17.4375C20.4986 17.4375 20.7371 17.3387 20.9129 17.1629C21.0887 16.9871 21.1875 16.7486 21.1875 16.5C21.1875 16.2514 21.0887 16.0129 20.9129 15.8371C20.7371 15.6613 20.4986 15.5625 20.25 15.5625C20.0014 15.5625 19.7629 15.6613 19.5871 15.8371C19.4113 16.0129 19.3125 16.2514 19.3125 16.5C19.3125 16.7486 19.4113 16.9871 19.5871 17.1629C19.7629 17.3387 20.0014 17.4375 20.25 17.4375ZM11.625 15.75H12V20.25H11.625C11.0039 20.25 10.5 19.7461 10.5 19.125V16.875C10.5 16.2539 11.0039 15.75 11.625 15.75ZM24.375 15.75C24.9961 15.75 25.5 16.2539 25.5 16.875V19.125C25.5 19.7461 24.9961 20.25 24.375 20.25H24V15.75H24.375Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_212_1765",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_1765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_1765",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_1765",
    x1: -9.31371,
    y1: 12.3137,
    x2: 13.3137,
    y2: 34.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A855F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_1765"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5H25.5V22.5H10.5V10.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChatMoniter);
export default __webpack_public_path__ + "static/media/ic_chat_moniter.92930aa8c10bed1060bc3ea1c2dbb008.svg";
export { ForwardRef as ReactComponent };